import { __awaiter } from "tslib";
import Chart from 'chart.js/auto';
import { useStore } from '@/store/store';
import { useMessage } from '@/const/messages';
import ApiManager from '@/managers/apimanagers';
import { ref } from 'vue';
/**
 * @summary 資産グラフを表示するための処理
 */
export const useAssetsRatioGraph = () => {
    const store = useStore();
    const isLoading = ref(false);
    const { DASHBOARD_PAGE, format } = useMessage();
    const chart = ref();
    const _error = (err) => Promise.reject(err);
    /**
     * グラフの作成処理
     * @param labels 通貨の名称一覧
     * @param datasets 通貨のデータセット
     */
    const createAssetsRatioChart = (data) => {
        if (chart.value) {
            chart.value.destroy();
        }
        const labels = data.labels;
        const datasets = [
            {
                barThickness: store.state.isSmartPhone ? 30 : 50,
                label: format(DASHBOARD_PAGE.STAKING),
                data: data.staking_percentage,
                backgroundColor: '#A339BD',
            },
            {
                barThickness: store.state.isSmartPhone ? 30 : 50,
                label: format(DASHBOARD_PAGE.BALANCE),
                data: data.balance_percentage,
                backgroundColor: '#356FC9',
            },
        ];
        const ctx = document.getElementById('assets_ratio_chart');
        chart.value = new Chart(ctx, {
            type: 'bar',
            data: {
                labels,
                datasets,
            },
            options: {
                plugins: {
                    legend: {
                        position: store.state.isSmartPhone ? 'top' : 'right',
                        display: true,
                        labels: {
                            boxWidth: store.state.isSmartPhone ? 10 : 12,
                            boxHeight: store.state.isSmartPhone ? 10 : 12,
                        },
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                let count = 0;
                                let text = 0;
                                data.labels.forEach((label) => {
                                    if (context.label == label) {
                                        text = context.datasetIndex === 0 ? data.staking[count] : data.balance[count];
                                    }
                                    count++;
                                });
                                return context.dataset.label + ':' + text;
                            },
                        },
                    },
                },
                responsive: true,
                indexAxis: 'y',
                scales: {
                    x: {
                        stacked: true,
                        min: 0,
                        max: 100,
                        ticks: {
                            callback: function (value) {
                                return value + '%';
                            },
                        },
                    },
                    y: {
                        stacked: true,
                    },
                },
            },
        });
    };
    /**
     * @returns グラフの再構成処理
     */
    const refresh = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isLoading.value) {
            return;
        }
        isLoading.value = true;
        const data = yield ApiManager.get(`/crypto-staking-graph`).catch(_error);
        if (Object.keys(data).length !== 0) {
            createAssetsRatioChart(data);
        }
        isLoading.value = false;
    });
    return {
        isLoading,
        createAssetsRatioChart,
        refresh,
    };
};
